import { useState, useEffect } from "react";
import { useAuth, api } from "../App";

export default function MobileStoriesBar({ onStoryTap, onProfileTap }) {
  const { user } = useAuth();
  const [team, setTeam] = useState([]);

  useEffect(() => {
    api.get("/team-members").then(r => {
      setTeam(r.data || []);
    }).catch(() => {
      api.get("/active-sessions").then(r => setTeam(r.data?.users || [])).catch(() => {});
    });
  }, []);

  const getInitials = (name) => (name || "?").split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase();
  const getHue = (name) => (name || "").split("").reduce((a, c) => a + c.charCodeAt(0), 0) % 360;

  const myInitials = getInitials(user?.name || user?.full_name);
  const myHue = getHue(user?.name || user?.full_name);
  const myPic = user?.profile_picture;

  return (
    <div className="ig-scroll" style={{
      display: 'flex', flexWrap: 'nowrap', gap: 12, padding: '10px 16px',
      overflowX: 'auto', scrollbarWidth: 'none',
      borderBottom: '1px solid #EFEFEF',
      WebkitOverflowScrolling: 'touch',
    }}>
      {/* Your Story — first avatar, opens profile */}
      <div onClick={() => onProfileTap && onProfileTap()}
        style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, cursor: 'pointer', flexShrink: 0 }}>
        <div style={{
          width: 62, height: 62, borderRadius: '50%',
          border: '1px solid #C7C7C7', background: 'none',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          position: 'relative',
        }}>
          <div style={{ width: 58, height: 58, borderRadius: '50%', background: '#FFF', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {myPic ? (
              <img src={myPic} alt="" style={{ width: 54, height: 54, borderRadius: '50%', objectFit: 'cover' }} />
            ) : (
              <div style={{ width: 54, height: 54, borderRadius: '50%', background: `hsl(${myHue}, 50%, 40%)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, fontWeight: 600, color: '#fff' }}>
                {myInitials}
              </div>
            )}
          </div>
          {/* Blue + badge */}
          <div style={{
            position: 'absolute', bottom: 0, right: 0,
            width: 18, height: 18, borderRadius: '50%',
            background: '#0095F6', border: '2px solid #FFF',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#fff', fontSize: 11, fontWeight: 700,
          }}>+</div>
        </div>
        <span style={{ fontSize: 10, color: '#262626', maxWidth: 60, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textAlign: 'center' }}>You</span>
      </div>

      {/* Team stories */}
      {team.slice(0, 12).map((u, i) => {
        const name = u.name || u.full_name || '';
        const pic = u.profile_picture;
        const seen = i > 2; // Simple seen logic — first 3 unseen
        return (
          <div key={i} onClick={() => onStoryTap && onStoryTap(u)}
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, cursor: 'pointer', flexShrink: 0 }}>
            <div style={{
              width: 62, height: 62, borderRadius: '50%',
              background: seen ? '#DBDBDB' : 'conic-gradient(from 180deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <div style={{ width: 58, height: 58, borderRadius: '50%', background: '#FFF', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {pic ? (
                  <img src={pic} alt="" style={{ width: 54, height: 54, borderRadius: '50%', objectFit: 'cover' }} />
                ) : (
                  <div style={{ width: 54, height: 54, borderRadius: '50%', background: `hsl(${getHue(name)}, 50%, 40%)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, fontWeight: 600, color: '#fff' }}>
                    {getInitials(name)}
                  </div>
                )}
              </div>
            </div>
            <span style={{ fontSize: 10, color: '#262626', maxWidth: 60, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textAlign: 'center' }}>
              {name.split(" ")[0]}
            </span>
          </div>
        );
      })}
    </div>
  );
}
